import { render, staticRenderFns } from "./JobRequestDetail.vue?vue&type=template&id=6c2ada58&"
import script from "@/services/applicant/job_request/job-request-detail.js?vue&type=script&lang=js&"
export * from "@/services/applicant/job_request/job-request-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports